<template>
    <vue-multiselect
            v-model="selected"
            :options="times"
            label="label"
            track-by="label"
            :showLabels="false"
            placeholder=""
            :open-direction="openDirection"
            :disabled="disabled"
            :searchable="true">
    </vue-multiselect>
</template>

<script>
/* globals moment */

export default {
  props: {
    value: {
      type: String,
      default: '',
    },

    start: {
      type: String,
      default: '08:00',
    },

    end: {
      type: String,
      default: '20:00',
    },

    interval: {
      type: Number,
      default: 30,
    },

    labelFormat: {
      type: String,
      default: 'HH:mm',
    },

    valueFormat: {
      type: String,
      default: 'HH:mm:ss',
    },

    openDirection: {
      type: String,
      default: 'auto',
    },

    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      times: [],
      selected: this.value ? this.formatTime(this.value) : '',
    };
  },

  watch: {
    selected(time) {
      this.$emit('input', time ? time.value : '');
    },

    value(time) {
      this.selected = time ? this.formatTime(time) : '';
    },
  },

  mounted() {
    const startTime = moment(this.start, 'HH:mm');
    const endTime = moment(this.end, 'HH:mm');

    while (startTime.isSameOrBefore(endTime)) {
      this.times.push({
        label: startTime.format(this.labelFormat),
        value: startTime.format(this.valueFormat),
      });
      startTime.add(this.interval, 'minutes');
    }
  },

  methods: {
    formatTime(time) {
      return {
        label: moment(time, this.valueFormat).format(this.labelFormat),
        value: time,
      };
    },
  },
};
</script>
